import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import "./App.scss";

// components

import Main from "../views/Main/component";
import AboutUs from "../views/AboutUs/component";
import ServiceInside from "../views/ServiceInside/component";
import AppDevelopment from "../views/AppDevelopment/component";
import DevOpsSolution from "../views/DevOpsSolution/component";
import News from "../views/News/component";
import NewsSinglePost from "../views/NewsSinglePost/component";

function App() {
  return (
    <>
      {/* <div class="loading animated slideOutRight">
        <div class="wrapper h-100">
          <div class="d-flex justify-content-center align-items-center h-100">
            <div class="loading-content">
              <div class="logo logo-primary">
                <img
                  class="animated zoomin"
                  src="assets/img/logo/logo-dark.svg"
                  alt="Logo"
                />
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <Router>
        <Routes>
          <Route exact path="/" element={<Main />} />
          <Route exact path="/about-us" element={<AboutUs />} />
          <Route exact path="/web-development" element={<ServiceInside />} />
          <Route exact path="/app-development" element={<AppDevelopment />} />
          <Route exact path="/dev-ops-solution" element={<DevOpsSolution />} />
          
          <Route exact path="/news" element={<News />} />
          <Route exact path="/news-single-post" element={<NewsSinglePost />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
